export default "__VITE_ASSET__CHYBKiSj__"